import { Field } from 'formik';
import { BaseUrlParamsFilter, BaseUrlParamsFilterProps } from '../../../filters/base-url-params-filter';
import { RegionPicker } from 'shared/ui/formik-fields/region-picker';
import { useSearchParams } from 'react-router-dom';

interface RegionParamFilterProps extends BaseUrlParamsFilterProps {
  countryQueryParamName?: string;
}

export const RegionParamFilter = ({ 
  queryParamName, 
  size = 'medium',
  countryQueryParamName = 'countryId'
}: RegionParamFilterProps) => {
  const [searchParams] = useSearchParams();
  
  const countryIdParam = searchParams.get(countryQueryParamName);
  const countryId = countryIdParam ? Number(countryIdParam) : null;

  return (
    <BaseUrlParamsFilter queryParamName={queryParamName}>
      <Field 
        fullWidth 
        name={queryParamName} 
        label={'Регион'} 
        clearable={true} 
        size={size} 
        countryId={countryId}
        component={RegionPicker} 
      />
    </BaseUrlParamsFilter>
  );
};
